import useFetchData from '../../../hooks/useFetchData';
import PropTypes from 'prop-types';
import PersonalDetailsContent from '../../PersonalDetails/components/content';

import translating from '../translate.json';
import { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import GlobalContext from 'contexts';
import { calcBMI, getAge } from 'utils';
import Meetings from 'components/Terapists/componenets/meetings';
import rightArrowIcon from '../../../assets/images/rightarrow.png';

import '../style.scss';
const MedicalInfo = () => {
  const { currentCustomer, setLink } = useContext(GlobalContext);
  const { id: clientUuid } = useParams();
  const [currentMeasers, setCurrentmeasures] = useState();
  let { data: measureData } = useFetchData('measure', clientUuid);
  const { data: meetingsData } = useFetchData(
    `client-therapist-scheduler/findClientMeetings/${clientUuid}`
  );
  const [currentMeetings, setCurrentMeetings] = useState();

  useEffect(() => {
    if (measureData?.length) {
      let cm = measureData.filter((m) => m.isActive === 1);
      setCurrentmeasures(cm);
    }
  }, [measureData]);

  useEffect(() => {
    if (meetingsData?.length) {
      setCurrentMeetings(meetingsData);
    }
  }, [meetingsData]);

  const medicalInfoFields = {
    general: [
      { label: translating.age, name: 'age' },
      { label: translating.gender, name: 'gender' },
      { label: translating.height, name: 'height' },
      { label: translating.weight, name: 'weight' },
      { label: 'BMI', name: 'bmi' }
    ],
    recentIndices: [
      { label: translating.fatPercentage, name: 'fatPct' },
      { label: translating.weightKG, name: 'whight' },
      { label: translating.pulse, name: 'heartBeatRate' },
      { label: translating.bloodPressure, name: 'bloodPressure' },
      { label: translating.flexibilityIndex, name: 'flexibilityIndex' },
      { label: translating.muscleMass, name: 'MuscleMass' },
      { label: translating.muscleStrength, name: 'muscleStrength' }
    ]
  };

  const medicalInfoData = {
    age: getAge(currentCustomer.date_of_birth),
    gender: currentCustomer.gender,
    height: currentCustomer.height,
    weight: currentCustomer.weight,
    bmi: calcBMI(currentCustomer.height, currentCustomer.weight)
  };

  return (
    <div className="medical-info-snapshot">
      <div className="title-navigation">
        <img src={rightArrowIcon} onClick={() => setLink(null)}></img>
        <div className="wrapper-title">
          <div className="user-name">
            {currentCustomer?.first_name} {currentCustomer?.last_name}
          </div>
        </div>
      </div>
      <div className="wrappper-snapshot-header"></div>
      <div className="box-details">
        <div className="box-details-title">{translating.generalInfo}</div>
        <PersonalDetailsContent
          fields={medicalInfoFields['general']}
          data={medicalInfoData}
          minWidth={'max-content'}
        ></PersonalDetailsContent>
      </div>
      {currentMeasers?.length ? (
        <div className="box-details">
          <div className="box-details-title">{translating.recentIndices}</div>
          <PersonalDetailsContent
            title={translating.recentIndices}
            fields={medicalInfoFields['recentIndices']}
            data={currentMeasers?.[0]}
          ></PersonalDetailsContent>
        </div>
      ) : (
        ''
      )}
      {/* <div className="box-details">
                <div className="box-details-title">{translating.reportsAndDocuments}</div>
            </div> */}
      {currentMeetings?.length && (
        <div className="box-details">
          <div className="box-details-title">רשימת פגישות</div>
          <Meetings data={currentMeetings}></Meetings>
        </div>
      )}
    </div>
  );
};

export default MedicalInfo;

MedicalInfo.propTypes = {
  clientId: PropTypes.string
};
